// UI-facing constants for the Unit Mining wizard. Discovery and enrichment
// now hit real ATTOM endpoints server-side (see server/lib/unitMining/) —
// this file only holds the selector options and the mapping from the UI's
// property-type labels to ATTOM's own propertyType values.

// No "Co-op" option: ATTOM's /property/address endpoint has no propertyType
// keyword or propertyindicator code for cooperative buildings at all (confirmed
// against both the live API and ATTOM's own docs) — there's no value that
// would ever return results, so the option was removed rather than left as a
// selector that silently never works. Same live sweep also confirmed ATTOM
// accepts commercial/industrial/retail/office/hotel/motel/vacant/mixed-use
// keywords, but those are deliberately excluded here — Unit Mining is scoped
// to residential owner-contact discovery, not commercial property.
export const PROPERTY_TYPES = ["Apartment", "Condo", "Duplex / Triplex / Quadplex", "Single Family Residence", "Mobile Home"];

// One UI type can map to more than one ATTOM keyword — ATTOM models
// "Duplex / Triplex / Quadplex" as three distinct propertyType values, but
// the UI offers them as a single chip. "Apartment" maps to two keywords for
// the same reason: larger complexes are frequently tax-assessed under
// ATTOM's generic "multi-family" bucket rather than its more specific
// "apartment" one (confirmed live — searching "apartment" alone missed a
// real complex that only showed up under "multi-family").
//
// All of a selection's resolved keywords go into ONE ATTOM search, joined
// with "|" — confirmed live that ATTOM's propertyType param supports
// pipe-delimited OR-combination in a single request (e.g. "duplex|triplex"
// returned exactly the deduped union of what two separate calls returned,
// verified by comparing result identifier ids). This is what lets
// discoverUnitsForType do one combined radius search instead of one call
// per keyword.
export const ATTOM_TYPE_MAP = {
	Apartment: ["apartment", "multi-family"],
	Condo: ["condominium"],
	"Duplex / Triplex / Quadplex": ["duplex", "triplex", "quadplex"],
	"Single Family Residence": ["single family residence"],
	"Mobile Home": ["mobile home"],
};

export const RADIUS_OPTIONS = ["100 ft", "150 ft", "250 ft", "500 ft", "1000 ft"];

export const DEFAULT_RADIUS = "150 ft";
